export function getdata() {
	var obj = {
		tableData: [],
		searchlist: [{
			prop: "noticeTime",
			label: '通知时间',
			type: "realdate",
			valueformat: 'yyyy-MM-dd'
		}, {
			prop: "noticeName",
			label: '通知名称',
			type: "input"
		}, {
			prop: "noticeType",
			label: '通知方式',
			type: "select",
			selectval: [{
				label: "短信",
				value: "1"
			}, {
				label: "邮箱",
				value: "2"
			}, {
				label: "钉钉机器人",
				value: "3"
			}, ]

		}, {
			prop: "name",
			label: '预警指标',
			type: "input"
		}, {
			prop: "companyName",
			label: '预警公司',
			type: "input"
		}, {
			prop: "noticeTemplateName",
			label: '通知模板',
			type: "input"
		}, {
			prop: "noticeResult",
			label: '推送结果',
			type: "select",
			selectval: [{
				label: "成功",
				value: "1"
			}, {
				label: "失败",
				value: "2"
			}, {
				label: "待推送",
				value: "3"
			}, ]
		}],
		headData: [{
			title: "通知时间",
			custom: true,
			prop: "noticeTime",
			width: "100"
		}, {
			title: "通知名称",
			custom: true,
			prop: "noticeName",
			width: 160,
			align: "left"
		}, {
			custom: true,
			title: "预警指标",
			prop: "name",
			width: "80",
			// custom: true,
		}, {
			custom: true,
			title: "预警公司",
			prop: "companyName",
			width: "80"
		}, {
			custom: true,
			title: "通用模板",
			prop: "noticeTemplateName",
			width: "80"
		}, {
			title: "通知方式",
			prop: "noticeType",
			width: "200",
			custom: true,
		}, {
			title: "推送结果",
			prop: "noticeResult",
			width: "80",
			custom: true,
		}, {
			title: "推送详情",
			prop: "bttsxp",
			width: 160,
			
			fixed: "right",
			custom: true
		}, ],
		headDatatop: [{
				title: "预警指标",
				prop: "companyName",
			},
			{
				title: "预警公司",
				prop: "name",
			}
		],
		headDatabottom: [{
				title: "姓名",
				prop: "userName",
			},
			{
				title: "短信",
				prop: "message",
				custom: true
			},
			{
				title: "邮箱",
				prop: "email",
				custom: true
			},

		],
		searchdata: {},
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		paginationz: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		paginationzz: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},

	}
	return obj
}
